import React from 'react';
import PropTypes from 'prop-types';

const AccountView = ({account}) => {
  return (
    <div className="genericPageContainer grey">
      <div className="genericTitleBar">Account Name, @Account</div>
      <div className="create-vizcode-container genericPageWrap titleBar grey">
        <div className="genericSettingsPanel gsp-left">
          <div className="genericSettingsForm">
            <h5 className="gsp-title">Account & Admin</h5>
            <div className="gsp-input">
              <p className="gsp-label">Account ID</p>
              <input className="gsp-textinp" value={account.id}/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Account Name</p>
              <input className="gsp-textinp" value={account.accountName}/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Admin Full Name</p>
              <input className="gsp-textinp" value={account.adminName}/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Admin Email Address</p>
              <input className="gsp-textinp" value={account.email}/>
            </div>
            <div className="gsp-input">
              <p className="gsp-label">Postal Address</p>
              <input className="gsp-textinp" valuer={account.address}/>
            </div>
            <div className="gsp-input gsp-input-last">
              <p className="gsp-label">Mobile Number</p>
              <input className="gsp-textinp" value={account.mobileNumber} placeholder="Optional" maxLength="11"/>
            </div>
          </div>
          <div className="gsp-footer">
            <input type="submit" className="gsp-button" value="Save Changes"/>
          </div>
        </div>
        <div className="genericSettingsPanel gsp-right">
          <h5 className="gsp-title">My VizCodes</h5>
        </div>
      </div>
    </div>
  );
};

AccountView.propTypes = {
  account: PropTypes.object.isRequired
};

export default AccountView;



// WEBPACK FOOTER //
// ./src/components/account/AccountView.js